module.exports = __webpack_public_path__ + "static/media/bg-main-studio.e69d3790.jpg";